import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Layout, PageHeader } from '../../common/components';
import { ChangePasswordPage } from './page';

const ChangePasswordHeader = (
  <PageHeader title="Profile" />
)

const ChangePassword = ({ match }) => (
  <Layout PageHeader={ChangePasswordHeader}>
    <Switch>
      <Route exact path={`${match.url}`} component={ChangePasswordPage} />
    </Switch>
  </Layout>
);

ChangePassword.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
};

ChangePassword.defaultProps = {
  match: {
    url: '',
  },
};

export default withRouter(ChangePassword);
